import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';


@Component({
  selector: 'app-reglaspesca',
  templateUrl: './reglaspesca.component.html',
  styleUrls: ['./reglaspesca.component.css']
})
export class ReglaspescaComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ReglaspescaComponent>
  ) { }

  ngOnInit() {
  }

  cerrarventana() {
    this.dialogRef.close();
  }

}
